import * as mobile from "./mobile";
import * as windowFactory from "client_legacy/ndaw/windowFactory";
import { navigateWindowTo } from "./navigator";
import { openAlertDialog } from "client/Components";
import { localize } from "./culture";


function download(fileUrl: string) {
	if (!canDownload()) {
		showCannotDownloadDialog();
		return;
	}

	const windowObject: Window | null = getOrCreateDownloadWindow();

	if (!windowObject) {
		throw new Error("No window object available for download");
	}

	downloadUsingWindow(fileUrl, windowObject);
}

function openInline(fileUrl: string) {
	const isInTheSameDomain = fileUrl.indexOf(window.location.origin) === 0;
	if (!isInTheSameDomain) {
		throw new Error(`Can't use openInline outside the same domain (${fileUrl})`);
	}

	// We can't use the safe way of opening a window here because there is a behavior difference between
	// 1) window.open(); window.location.href = fileUrl;
	// 2) window.open(fileUrl);
	// In case 1 when a file is downloaded inline by the browser, it will not close the opened tab
	// while in case 2 it will.
	// There is no clear way to determine whether the browser downloaded the file or displayed it inline.
	// So to keep this behavior we allow directly using window.open but only if the origin is the same
	// as the current window
	const newWindow: Window | null = windowFactory.openUnsafe(fileUrl);
	if (newWindow) {
		newWindow.focus();
	}
}

function getOrCreateDownloadWindow(): Window | null {
	let windowObject: Window | null = window;

	if (window.mobileApp) {
		return windowObject;
	}

	if (mobile.isTabletOrMobile()) {
		// create a new window without a url
		windowObject = windowFactory.open();
	}

	return windowObject;
}

function downloadUsingWindow(fileUrl: string, windowObject: Window) {
	if (window.mobileApp) {
		// Downloads in the mobile app must be bridged into the app code and handled by the app itself.
		window.mobileApp.downloadFileFromUrl(fileUrl);
		return;
	}

	navigateWindowTo(fileUrl, windowObject);

	// If the given windowObject was not the current window but a newly opened one
	// we focus it
	if (windowObject !== window) {
		windowObject.focus();
	}
}

function canDownload() {
	return !mobile.isIOsStandAlone();
}

function showCannotDownloadDialog() {
	openAlertDialog({
		title: localize("_DownloadNotPossibleOnIpadHomescreenTitle"),
		children: localize("_DownloadNotPossibleOnIpadHomescreenMessage"),
		confirmText: localize("_Close"),
		trackingId: "file-download-ipad-impossible-dialog"
	});
}

export {
	download,
	getOrCreateDownloadWindow,
	downloadUsingWindow,
	canDownload,
	showCannotDownloadDialog,
	openInline
};
